import React from 'react';
import { useTranslation } from 'react-i18next';
import MerchantRulesTable from 'Components/MerchantRulesTable';
import useGetRuleColumns from 'Hooks/useGetRuleColumns';

type Props = {
    globalRules: GlobalRulesData;
    merchantRules: MerchantRulesData;
    merchantId: any;
};

const MerchantTable = ({ globalRules, merchantRules, merchantId }: Props) => {
    const { t } = useTranslation();

    const columnNames = useGetRuleColumns({
        columns: [
            'modifiedFlag',
            {
                Header: () => null,
                id: 'overrideGroup',
                disableSortBy: true,
                accessor: (d) => {
                    return `${d?.overrideGroup}`;
                },
                // these would correspond to values in the group by accessor values
                groupByOrder: {
                    [t('Merchant Overrides')]: 0,
                    [t('Global Rules')]: 1
                }
            },
            'ruleId',
            'inputDescription',
            'conclusion',
            'override',
            'lastModified',
            'status'
        ]
    });

    return (
        <MerchantRulesTable
            tableName={`sandxbox-merchants-table-${merchantId}`}
            merchantId={merchantId}
            globalRules={globalRules}
            merchantRules={merchantRules}
            columnNames={columnNames}
            mode='sandbox'
        />
    );
};

export default MerchantTable;
